import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import {
  CategoriesSection,
  TrendingSection,
  AvoidSection,
  OrderSection,
  ReviewSection,
} from "./components/Sections";
import { FaqSection, TestimonialsSection, CtaBanner } from "./components/SocialFaq";
import { faqs } from "@/mocks/anime";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar transparent />
      <main>
        <Hero />
        <CategoriesSection />
        <TrendingSection />
        <AvoidSection />
        <OrderSection />
        <ReviewSection />
        <FaqSection />
        <TestimonialsSection />
        <CtaBanner />
      </main>
      <Footer />
    </>
  );
}